import { render } from "./ResultView.vue?vue&type=template&id=d8c370da&scoped=true&ts=true"
import script from "./ResultView.vue?vue&type=script&lang=ts"
export * from "./ResultView.vue?vue&type=script&lang=ts"

import "./ResultView.vue?vue&type=style&index=0&id=d8c370da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8c370da"]])

export default __exports__